<div class="container pt-5">
    <table class="table">
        <thead>
            <tr>
                <th scope="col"></th>
                <th scope="col">Cause</th>
                <th scope="col">Email</th>
                <th scope="col">Name</th>
                <th scope="col">Creation</th>
                <th scope="col">LastMood</th>
                <th scope="col">Team(s)</th>
                <th scope="col">Provider</th>
                <th scope="col">Actions</th>
            </tr>
        </thead>

        <tbody>
            @if (loading) {
            <tr>
                <td colspan="9" class="text-center p-2 border-0">
                    <i class="far fa-spinner fa-spin"></i>
                </td>
            </tr>
            }
            @for (bounce of bouncesData; track bounce) {
            <tr>
                <td>@if (!bounce.isSpam) {
                    <span title="spam"> <i
                            class="fal fa-file-exclamation text-danger"></i>
                    </span>
                    }</td>

                <td>{{ bounce.cause }}</td>

                <td
                    [ngStyle]="{ 'color':  (bounce.teamMember.isActive == false) ? 'grey' : ''}">
                    <a href="#/admin/search?query={{bounce.teamMember.id}}"
                        target="_blank">{{ bounce.teamMember.email }}</a>
                </td>

                <td
                    [ngStyle]="{ 'color':  (bounce.teamMember.isActive == false) ? 'grey' : ''}">
                    <a href="#/admin/search?query={{bounce.teamMember.id}}"
                        target="_blank">{{ bounce.teamMember.name }}</a>
                </td>

                <td>{{ bounce.teamMember.createdAgo }}</td>

                <td>{{ bounce.teamMember.lastMoodDateAgo }}</td>

                <td>
                    @for (team of bounce.teamMember.teams; track team) {
                    <div class="pb-2"
                        [ngStyle]="{ 'color':  (team.isActive == false) ? 'grey' : ''}">
                        <label
                            [ngStyle]="{ 'color':  (team.activeInTeam == false) ? 'grey' : ''}">
                            <a
                                ui-sref="main.team_members_setup({teamId: team.id})"
                                target="_blank">{{ team.name }}</a>
                        </label>
                        <tm-slide-toggle [ngModel]="team.activeInTeam"
                                        (ngModelChange)="activeInTeamChanged(bounce, team)"></tm-slide-toggle>
                    </div>
                    }
                </td>

                <td>
                    <a
                        href="https://account.postmarkapp.com/servers/4488290/streams/outbound/messages/{{bounce.messageId}}"
                        target="_blank">{{ bounce.provider }}</a>
                </td>

                <td>
                    <div class="btn-group">
                        <a class="btn btn-primary"
                            href="{{generateMailTo(bounce.teamMember)}}"
                            target="_blank">
                            <i class="fa fa-paper-plane"></i>
                        </a>
                        <button class="btn btn-danger"
                            (click)="remove(bounce.teamMember.id)">
                            <i class="fa fa-trash-alt"></i>
                        </button>
                    </div>
                </td>
            </tr>
            }
        </tbody>

    </table>

    <div class="text-center">
        <button class="btn btn-danger" (click)="deleteAll(bouncesData)">
            Delete all bounces
        </button>
    </div>

</div>